<script lang="ts">
	import { createDialog, melt } from '@melt-ui/svelte';
	import type { ChangeFn } from '@melt-ui/svelte/internal/helpers';
	import { X } from 'lucide-svelte';
	import type { Snippet } from 'svelte';
	import SignupForm from '../routes/(unauthenticated)/signup/SignupForm.svelte';

	interface Props {
		onOpenChange: ChangeFn<boolean>;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		children?: Snippet<[any]>;
	}

	let { onOpenChange, children }: Props = $props();

	const {
		elements: { trigger, overlay, content, close, portalled },
		states: { open }
	} = createDialog({
		role: 'alertdialog',
		onOpenChange
	});
</script>

{@render children?.($trigger)}

<div use:melt={$portalled}>
	{#if $open}
		<div use:melt={$overlay} class="fixed inset-0 z-50 bg-black/50"></div>
		<div
			class="bg-white-pure fixed top-0 right-0 bottom-0 left-0 z-50 mx-auto my-auto h-[100svh] w-full max-w-screen-md overflow-auto p-6 lg:h-5/6 lg:rounded-2xl"
			use:melt={$content}
		>
			<button use:melt={$close} aria-label="Close" class="absolute top-2 right-2">
				<X class="h-6 w-6" />
			</button>
			<div class="mx-auto max-w-sm">
				<SignupForm />
			</div>
		</div>
	{/if}
</div>
